var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "SI_4L_stroke",
    cx: 21.2,
    cy: 21.2,
    r: 17.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_fill_red",
    d: "M26.9 20.3l3.9-3.9c.5-.5.5-1.4 0-2l-2.7-2.7c-.5-.5-1.4-.5-2 0l-3.9 3.9c-.5.5-1.4.5-2 0l-3.9-3.9c-.5-.5-1.4-.5-2 0l-2.7 2.7c-.5.5-.5 1.4 0 2l3.9 3.9c.5.5.5 1.4 0 2l-3.9 3.9c-.5.5-.5 1.4 0 2l2.7 2.7c.5.5 1.4.5 2 0l3.9-3.9c.5-.5 1.4-.5 2 0l3.9 3.9c.5.5 1.4.5 2 0l2.7-2.7c.5-.5.5-1.4 0-2l-3.9-3.9c-.6-.6-.6-1.5 0-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo);
export default __webpack_public_path__ + "static/media/no.b25054158a55c9fcef396ec52fa5c636.svg";
export { ForwardRef as ReactComponent };